/* OutboundSyslogAdvPrefsComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");
const escapeHtml = require("@gluenetworks/dom_utilities").escapeHtml;

const Renderer = require("./OutboundSyslogAdvPrefsRenderer");

class OutboundSyslogAdvPrefsComponent extends EventEmitter {
    constructor(data, uiUtils) {
        super();
        this._data = data;
        this._uiUtils = uiUtils;
        this._entity = this._data._outboundSyslogEntity;
        this._enabled = this._data._enabled;
        this._advData = {
            syslogServerPort: this._entity.syslogServerPort,
            syslogServerProtocol: this._entity.syslogServerProtocol,
            syslogServerTcpTimeout: this._entity.syslogServerTcpTimeout,
            syslogServerTlsClientCert: this._entity.syslogServerTlsClientCert,
            syslogServerTlsClientKey: this._entity.syslogServerTlsClientKey,
            syslogServerTlsServerCerts: this._entity.syslogServerTlsServerCerts,
            allowUnauthorizedServerCertificates: this._entity.allowUnauthorizedServerCertificates,
        };
        this._updatedData = {
            syslogServerPort: this._entity.syslogServerPort,
            syslogServerProtocol: this._entity.syslogServerProtocol,
            syslogServerTcpTimeout: this._entity.syslogServerTcpTimeout,
            syslogServerTlsClientCert: this._entity.syslogServerTlsClientCert,
            syslogServerTlsClientKey: this._entity.syslogServerTlsClientKey,
            syslogServerTlsServerCerts: this._entity.syslogServerTlsServerCerts,
            allowUnauthorizedServerCertificates: this._entity.allowUnauthorizedServerCertificates,
        };
        this._host = this._entity.syslogServerAddress;
        this._renderer = new Renderer(this);
        this._renderer.render();
    }

    shutdown() {
        return Promise.resolve();
    }

    closePopUp() {
        this.rejectPopUp({userRejected: true});
    }

    rejectPopUp(data) {
        this._context.reject(data);
    }

    resolvePopup(data) {
        this._context.resolve(data);
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    isDirty() {
        return _.isEqual(this._advData, this._updatedData);
    }

    generateSlickData(certs = []) {
        return certs.map((cert, idx) => {
            return {
                id: idx,
                certificate: cert,
            };
        });
    }

    testSyslog() {
        const prefs = Object.assign(
            {},
            _.cloneDeep(this._entity.properties),
            _.cloneDeep(this._updatedData)
        );
        const protocol = _.get(this._updatedData, "syslogServerProtocol", "");
        let message;

        return this._data._OutboundSyslogEntity
            .sendTestSyslogMessage(prefs)
            .then((data) => {
                const safeHost = escapeHtml(this._host);
                if (data.success) {
                    if (protocol === "udp") {
                        message =
                            "A message has been sent to the syslog server at " +
                            safeHost +
                            ". Please verify that it was delivered to the server.<br \\>";
                        message +=
                            "<p class='sub'>Message: \"" + escapeHtml(data.messageSent) + '"</p>';
                    } else {
                        message = "Success. You connected to the syslog server " + safeHost + ".";
                    }
                } else {
                    if (protocol === "udp") {
                        message =
                            "There's a problem. Sending a message to the syslog server " +
                            safeHost +
                            " failed.<br \\>" +
                            escapeHtml(data.error);
                    } else {
                        message =
                            "There's a problem. The connection to the syslog server " +
                            safeHost +
                            " failed.<br \\>" +
                            escapeHtml(data.error);
                    }
                }
            })
            .catch((error) => {
                message = "Error sending message.";
                this._logger.warn({error});
            })
            .finally(() => {
                this._uiUtils.showMessageDialog({
                    message: message,
                    confirmButtonName: "OK",
                    enableHtml: true,
                });
            });
    }
}

module.exports = OutboundSyslogAdvPrefsComponent;
